import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolsWrenchHold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "tools-wench-hold" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.697,
			y1: 8.432,
			x2: 11.379,
			y2: 12.75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12.257,17.871a3,3,0,0,0,0-4.242l-2.068-2.068a1.5,1.5,0,0,0-2.121,0L3.439,16.189a1.5,1.5,0,0,0,0,2.122l2.068,2.068a3,3,0,0,0,4.243,0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.629,12a2.493,2.493,0,0,1,0-3,1.511,1.511,0,0,1,2.25,0l4.06,4.061a2.742,2.742,0,0,1,0,3.878,1.5,1.5,0,0,0,0,2.122l4.19,4.189"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 4.629,
			y1: 19.5,
			x2: .879,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 7.874,
			y1: 21.246,
			x2: 9.879,
			y2: 23.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.379,6.75a1.5,1.5,0,0,1,0-3h2.742a4.5,4.5,0,1,0,0,3Z"
		})
	]
});
export default SvgToolsWrenchHold;
